import {DiaryItem, DiaryContent, TodoItem} from '@dv5/domain'

export const parseContent = (content: string): { items: DiaryItem[]; todos: TodoItem[] } => {
    try {
        const parsed = JSON.parse(content) as DiaryContent
        return {
            items: parsed.items || [],
            todos: parsed.todos || [],
        }
    } catch {
        return { items: [], todos: [] }
    }
}

export const saveContent = (
    items: DiaryItem[],
    todos: TodoItem[],
    setContent: (content: string) => void
) => {
    if (items.length === 0 && todos.length === 0) {
        setContent('')
    } else {
        setContent(JSON.stringify({ items, todos }))
    }
}

export const datetimeToTimestamp = (datetimeValue: string): number => {
    if (!datetimeValue) return Date.now()
    return new Date(datetimeValue).getTime()
}

export const timestampToDatetime = (timestamp: number): string => {
    if (!timestamp) return ''
    const date = new Date(timestamp)
    const offset = date.getTimezoneOffset()
    const localDate = new Date(date.getTime() - offset * 60000)
    return localDate.toISOString().slice(0, 16)
}

export const formatTimestamp = (timestamp: number): string => {
    const date = new Date(timestamp)
    const day = String(date.getDate()).padStart(2, '0')
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const year = date.getFullYear()
    const hours = String(date.getHours()).padStart(2, '0')
    const minutes = String(date.getMinutes()).padStart(2, '0')
    const seconds = String(date.getSeconds()).padStart(2, '0')
    return `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`
}
